import util from '../util'

let controller = 'ParceiroDominio'
export default Object.assign({}, util.GetCrud(controller, null))